import { render, staticRenderFns } from "./SurveyComponent2.vue?vue&type=template&id=25dd9112&scoped=true&"
import script from "./SurveyComponent2.vue?vue&type=script&lang=js&"
export * from "./SurveyComponent2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd9112",
  null
  
)

export default component.exports